module.exports = __webpack_public_path__ + "static/media/klima-01.6d69c0c3.jpg";